import * as React from "react";
const LinkedInSvg = (props) => (
  <svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M0 1.707C0 .765.788 0 1.761 0h20.308c.973 0 1.761.765 1.761 1.707v20.416c0 .943-.788 1.707-1.761 1.707H1.761C.788 23.83 0 23.066 0 22.123V1.707Z"
    />
    <path
      fill={props.additColor}
      fillRule="evenodd"
      d="M6.807 19.625V9.221H3.692v10.404h3.115ZM5.25 7.801c1.086 0 1.762-.8 1.762-1.798-.02-1.02-.676-1.797-1.742-1.797-1.065 0-1.762.776-1.762 1.797 0 .999.676 1.798 1.721 1.798h.02ZM9.11 19.625h3.444v-5.736c0-.307.022-.614.113-.834.249-.613.816-1.248 1.767-1.248 1.246 0 1.745.942 1.745 2.323v5.495h3.444v-5.89c0-3.155-1.7-4.623-3.966-4.623-1.857 0-2.673 1.03-3.126 1.73h.023v-1.49H9.109c.046.965 0 10.273 0 10.273Z"
      clipRule="evenodd"
    />
  </svg>
);
export default LinkedInSvg;
